export const enMeritocracyPageTranslation = {
  meritocracy: {
    actions: {
      download: 'Export simulation to excel',
      only_simulated: 'Only simulated',
    },
    simulation: {
      title: 'Meritocracy Simulation',
      description: 'Select or create a new scenario for simulations',
    },
    recommendation: {
      title: 'Meritocracy Recommendation',
    },
  },
};
